import React from 'react'

import CreditsSection from './components/credits'
import LimitsSection from './components/limits'

const CreditsAndLimits = (props) => {

  return (
    <div className="container overflow-hidden">
      <div className="row gx-5">
        <div className="col-12 col-md-6 mb-3 mb-md-0">
          <CreditsSection {...props} />
        </div>
        <div className="col-12 col-md-6">
          <LimitsSection {...props} />
        </div>
      </div>
    </div>
  )
}

export default CreditsAndLimits
